import React, { Component } from 'react';
import { intlShape, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';

const tokenPromises = {};

export const withStripeElementsUnwrapped = StripeForm =>
  class StripeElementsForm extends Component {
    static propTypes = {
      intl: intlShape,
      onLoadingStateChanged: PropTypes.func.isRequired,
      onTokenPromiseKey: PropTypes.func.isRequired,
    };

    constructor(props) {
      super(props);

      this.onSetStripePromise = this.onSetStripePromise.bind(this);
    }

    state = {};

    componentDidMount() {
      if (window.Stripe) {
        this.stripeAvailable();
      } else {
        this.stripeAvailabilityListener = this.stripeAvailable.bind(this);
        document.body.addEventListener('stripeReady', this.stripeAvailabilityListener);
      }
    }

    componentWillUnmount() {
      if (this.stripeAvailabilityListener) {
        document.body.removeEventListener('stripeReady', this.stripeAvailabilityListener);
        delete this.stripeAvailabilityListener;
      }

      const { tokenPromiseKey } = this.state;
      if (tokenPromiseKey) {
        delete tokenPromises[tokenPromiseKey];
      }
    }

    onSetStripePromise(stripePromise) {
      const { onTokenPromiseKey } = this.props;

      const tokenPromiseKey = String(Math.random()).substr(2, 10);
      tokenPromises[tokenPromiseKey] = stripePromise;
      onTokenPromiseKey(tokenPromiseKey);

      this.setState({
        tokenPromiseKey,
      });
    }

    getCurrentLanguage() {
      const {
        intl: { locale: currentLocale },
      } = this.props;

      return currentLocale.split('-')[0];
    }

    stripeAvailable() {
      if (this.stripeAvailabilityListener) {
        document.body.removeEventListener('stripeReady', this.stripeAvailabilityListener);
        delete this.stripeAvailabilityListener;
      }

      const stripe = window.Stripe;
      const elements = stripe.elements({ locale: this.getCurrentLanguage() });

      const { onLoadingStateChanged } = this.props;

      onLoadingStateChanged(false);

      this.setState({
        stripe,
        elements,
      });
    }

    render() {
      const { stripe, elements, tokenPromiseKey } = this.state;

      return (
        <StripeForm
          stripe={stripe}
          elements={elements}
          tokenPromise={tokenPromiseKey}
          setStripePromise={this.onSetStripePromise}
          {...this.props}
        />
      );
    }
  };

export const withStripeElements = StripeForm => injectIntl(withStripeElementsUnwrapped(StripeForm));

export const getTokenPromise = key => tokenPromises[key];
export const isStripeError = err => err && err.isStripeError;
export const isStripeValidationError = err => isStripeError(err) && err.type === 'validation_error';
